// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".elder-choices{display:flex;flex-wrap:wrap;margin-bottom:-1rem;margin-left:-1rem}.elder-choices__item{font-size:inherit;font-weight:700;display:flex;align-items:center;flex-direction:column;flex-grow:1;margin-bottom:1rem;margin-left:1rem;cursor:pointer;transition:background-color .15s ease-out,color .15s ease-out;border:1px solid var(--vue-elder-border-color,#eaeaea);border-radius:var(--vue-elder-border-radius,3px);outline:none!important;background-color:#fff}.elder-choices__item--active{border-color:var(--vue-elder-primary,#3a9acd);background-color:var(--vue-elder-primary,#3a9acd);color:var(--vue-elder-primary-contrast,#fff)}.elder-choices__item-image{flex-grow:1;padding:1rem 2rem 0}.elder-choices__item-label{padding:1rem 2rem}", ""]);
// Exports
exports.locals = {
	"primary": "#1d56d8",
	"secondary": "#4274e6",
	"warning": "#e9ab05",
	"success": "#0abb59",
	"error": "#e7201b",
	"light-grey": "#f7f7f7",
	"dark": "#272727",
	"grey": "#e3e3e3"
};
module.exports = exports;
